import {
	Button,
	Pagination,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";

interface ISelectedTemplateState {
	_id: string;
	name: string;
}

interface ITemplateList {
	value?: ISelectedTemplateState | null | undefined;
	onChange?: (val: ISelectedTemplateState) => unknown;
}

// type TDashboardData = {
//     _id: string;
//     name: string;
//     dateAdded: string;
// };

function TemplateList(props: ITemplateList) {
	const { onChange, value } = props;

	const [page, setPage] = useState(1);

	const {
		data: templates,
		isLoading,
		refetch,
	} = useQuery(["superadmin", "get-dashboard-teplates"], () => {
		return developAxios(localStorage.getItem("token") || "")
			.get<{
				data: ISelectedTemplateState[];
			}>("/superadmin/course/dashboard-templates")
			.then(({ data }) => data.data);
	});

	useEffect(() => {
		refetch();
	}, [page, refetch]);

	return (
		<div>
			{!isLoading && templates && (
				<TableContainer component={Paper}>
					<Table sx={{ width: "100%" }}>
						<TableHead>
							<TableRow>
								<TableCell>Name</TableCell>
								<TableCell>Actions</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{templates &&
								templates.map((template) => (
									<TableRow key={template._id}>
										<TableCell>{template.name}</TableCell>
										<TableCell>
											<Button
												variant={"contained"}
												onClick={() =>
													onChange &&
													onChange({
														_id: template._id,
														name: template.name,
													})
												}
												color={
													template._id === value?._id
														? "success"
														: "primary"
												}
											>
												{template._id === value?._id
													? "Selected"
													: "Select"}
											</Button>
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			<Pagination
				page={page}
				count={10}
				color="primary"
				onChange={(_e, value: number) => setPage(value)}
			/>
		</div>
	);
}

export default TemplateList;
